export default __webpack_public_path__ + "b1220cedb36e659d5506f651974e3f19.png";